<template>
  <filter-wrapper>
    <z-form ref="form" @submit.prevent.native="submit">
      <template slot="default">
        <div class="filter__row">
          <div class="filter__item col-6">
            <z-form-input
              class="filter__item__body"
              :rules="{ required: true }"
              :show_errors="false"
            >
              <template>
                <v-autocomplete
                  :items="items"
                  item-text="name"
                  item-value="id"
                  hide-details="auto"
                  :label="$t(`${label}`)"
                  v-model="form.filter"
                  multiple
                  :chips="chips"
                  outlined
                  dense
                >
                  <template v-slot:selection="{ item }">
                    <v-chip 
                      class="mdi-close"
                      close
                      x-small
                      color="#D6E2EF"
                      @click:close="remove(item)"
                    >
                      <span>{{ item.name }}</span>
                    </v-chip>
                  </template>
                  <template v-slot:prepend-item>
                    <v-list-item
                      ripple
                      @click="toggle"
                      :class="{all: allFilter}"
                    >
                      <v-list-item-action>
                        <v-icon :color="form.filter.length > 0 ? 'indigo darken-4' : ''">
                          {{ icon }}
                        </v-icon>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>
                          Все
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </template>
            </z-form-input>
          </div>
        </div>
        <div class="filter__row ml-0">
          <div class="filter__item filter__item--button ml-0">
            <v-btn 
              class="btn-success ml-0"
              raised
              color="#394858"
              size="large"
              @click="submit"
            >
              {{ $t('shared.component.filter.show_result') }}
            </v-btn>
          </div>
        </div>
      </template>
    </z-form>
  </filter-wrapper>
</template>

<script>
  import FilterWrapper from '@shared/components/filter-base';
  import { mapActions } from 'vuex';
  import { MonitoringService } from '@monitoring/services/MonitoringService';

  export default {
    components: {
      FilterWrapper
    },
    data() {
      return {
        items: [],
        chips: true,
        label: 'monitoring.field.group',
        form: {
          filter: [],
          group_by: 'date',
          trunk_id: null,
          assigned: '',
          project: '',
          state_id: '',
          country_code: null,
          date: null
        }
      };
    },

    async created() {
      await MonitoringService.getFilter()
        .then((data) => {
          this.items = data || [];
          this.form.filter = data.map((el) =>  el.id) || [];
        })
        .then(() => this.submit())
        .then(() => setInterval(() => {
          this.submit()
        }, 3000) )
    },
    computed: {
      allFilter () {
        return this.form.filter ? this.form.filter.length === this.items.length : false
      },
      someFilter () {
        return this.form.filter ? this.form.filter.length > 0 && !this.allFilter : true
      },
      icon () {
        console.log(this.allFilter, 'all')
        if (this.allFilter) return 'mdi-close-box'
        if (this.someFilter) return 'mdi-minus-box'
        return 'mdi-checkbox-blank-outline'
      }
    },
    methods: {
      ...mapActions('monitoring/employees/table', { searchEmployees: 'search' }),
      ...mapActions('monitoring/groups/table', { searchGroups: 'search' }),
      ...mapActions('monitoring/calls/table', { searchCalls: 'search' }),
      remove(item) {
        this.form.filter.splice(this.form.filter.indexOf(item.id), 1)
        this.form.filter = [...this.form.filter]
      },
      toggle () {
        this.$nextTick(() => {
          if (this.allFilter) {
            this.form.filter = []
          } else {
            this.form.filter = this.items.map((el) =>  el.id)
          }
        })
      },
      submit() {
        this.$refs.form.validate().then(is_valid => {
          if (is_valid) {
            const params = {
              group_ids: [...this.form.filter]
            };
            this.searchEmployees(params);
            this.searchGroups(params);
            this.searchCalls(params);
          }
        });
      }
    }
  };
</script>
<style lang="scss" scoped>
.v-list-item--link:before {
    background: unset;
  }
  .v-list-item--link.all:before {
    background: rgba(0, 0, 0, 0.87);
  }
</style>
